import * as ActionTypes from '../../constants/ActionTypes';
import API from '../../helpers/api';

export function getPersonalParticularByApplicationId(id){
	return async dispatch => {
		dispatch({
			type: ActionTypes.GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_SUCCESS,
			payload: {
				loading: true
			}
		});

		const response = await API.personal_particular.getPersonalParticularByApplicationId(id);

		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
			return;
		}

		const { personalInfo } = response.data;

		dispatch({
			type: ActionTypes.GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_SUCCESS,
			payload: {
				personalInfo,
				loading: false
			}
		});
	};
}

export function onPersonalParticularSubmit({ id, fields }){
	return async dispatch => {
		dispatch({
			type: ActionTypes.SUBMIT_PERSONAL_PARTICULAR_REQUEST,
			payload: {
				loadingSubmit: true
			}
		});

		let response;
		if(!id){
			response = await API.personal_particular.createPersonalParticular(fields);
		} else {
			response = await API.personal_particular.updatePersonalParticular(id, fields);
		}
	
		if(response.meta.code !== 200) {
			dispatch({
				type: ActionTypes.GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_ERROR,
				payload: {
					meta: response.meta,
					loadingSubmit: false
				}
			});
			return;
		}

		const { personalInfo } = response.data;

		dispatch({
			type: ActionTypes.GET_PERSONAL_PARTICULAR_BY_APPLICATION_ID_SUCCESS,
			payload: {
				personalInfo,
				loadingSubmit: false,
				meta: response.meta
			}
		});
	};
}

export function resetPersonalParticularPage() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_PERSONAL_PARTICULAR_PAGE
		});
	};
}

export function resetPersonalParticularMeta() {
	return async dispatch => {
		dispatch({
			type: ActionTypes.RESET_PERSONAL_PARTICULAR_META
		});
	};
}